export default defineNuxtPlugin(async () => {
  const { $i18n } = useNuxtApp()

  // Function to get saved locale from localStorage
  const getSavedLocale = () => {
    if (import.meta.client) {
      return localStorage.getItem('user-locale')
    }
    return null
  }

  // Function to save locale to localStorage
  const saveLocale = (locale: string) => {
    if (import.meta.client) {
      localStorage.setItem('user-locale', locale)
    }
  }

  // On app initialization, check for saved locale or default to 'fa'
  if (import.meta.client) {
    const savedLocale = getSavedLocale()

    // If user has manually selected a locale before, use it
    if (savedLocale && (savedLocale === 'fa' || savedLocale === 'en')) {
      if (savedLocale !== $i18n.locale.value) {
        await $i18n.setLocale(savedLocale as 'fa' | 'en')
      }
    } else {
      // Always default to Persian if no saved preference
      if ($i18n.locale.value !== 'fa') {
        await $i18n.setLocale('fa')
      }
      saveLocale('fa')
    }
  }

  // Watch for locale changes and save them
  watch(() => $i18n.locale.value, (newLocale) => {
    if (newLocale) {
      saveLocale(newLocale)
    }
  })

  return {
    provide: {
      saveLocale
    }
  }
})
